import { motion } from "framer-motion";

const images = [
  {
    url: "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/kujwlks2_Screenshot%202026-07-08%20150521.jpg",
    label: "Bridge Construction Progress",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/gw30j23r_b0f383fe-d9cb-4b61-98cc-08c612d05d19.webp",
    label: "Powerline Thermal Inspection",
    span: "",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/21b19545_WhatsApp%20Image%202025-10-29%20at%2010.06.48%20AM.jpeg",
    label: "Road Corridor Monitoring",
    span: "",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts/grhqax9j_Screenshot%202026-07-08%20150135.webp",
    label: "Detail & Contour Survey — Kalva",
    span: "lg:col-span-2",
  },
];

export const Portfolio = () => {
  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">
            Our Work
          </span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            Aerial captures from the field
          </h2>
          <p className="mt-4 text-[#52525b]">
            A glimpse of the surveys, inspections and productions we deliver
            across sectors.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[220px] gap-4">
          {images.map((img, i) => (
            <motion.figure
              key={i}
              data-testid={`portfolio-item-${i}`}
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`group relative overflow-hidden rounded-sm border border-gray-200 ${img.span}`}
            >
              <img
                src={img.url}
                alt={img.label}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#10193f]/80 via-transparent to-transparent" />
              <figcaption className="absolute bottom-4 left-4 text-white font-heading font-bold text-lg">
                {img.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
